"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FHeader = void 0;
const react_1 = __importDefault(require("react"));
const ferrum_brand_logo_png_1 = __importDefault(require("../../assets/images/ferrum-brand-logo.png"));
const FHeader = ({ headerLogo = ferrum_brand_logo_png_1.default, showLogo = true, headerSearch, titleText = "", children = undefined, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("header", { className: "f-header f-layout-component" },
            react_1.default.createElement("div", { className: "f-logo f-mobile" },
                react_1.default.createElement("img", { src: headerLogo ? ferrum_brand_logo_png_1.default : headerLogo, alt: "Logo" })),
            showLogo === true && headerLogo && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "f-logo" },
                    react_1.default.createElement("img", { src: ferrum_brand_logo_png_1.default, alt: "Logo" })))),
            headerSearch && (react_1.default.createElement("div", { className: "form-group" },
                react_1.default.createElement("input", { type: "text", className: "form-control" }))),
            titleText && react_1.default.createElement("h3", { className: "f-header-title m-0 mx-4" }, titleText),
            react_1.default.createElement("div", { className: "f-header-items" }, children))));
};
exports.FHeader = FHeader;
//# sourceMappingURL=Fheader.js.map